module.exports = __webpack_public_path__ + "static/media/plan-50gigas.fadbf831.svg";